import { transformSerieName } from './transformSerieName';

export const getModelImageUrl = (model: string) => {
  return `${
    process.env.REACT_APP_TOYOTA_CERTIFIED_IMAGE_URL
  }/${transformSerieName(model)}.png`;
};
